import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 1024px)";

export default function Sidebar({ active, setActive }) {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  const [open, setOpen] = useState(() => !window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);

    const handleMediaChange = (event) => {
      const mobile = event.matches;
      setIsMobile(mobile);
      if (mobile) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };

    handleMediaChange(media);

    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", handleMediaChange);
      return () => media.removeEventListener("change", handleMediaChange);
    }

    media.addListener(handleMediaChange);
    return () => media.removeListener(handleMediaChange);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [active, isMobile]);

  const menu = [
    { key: "analytics", label: "📊 Analytics" },
    { key: "orders", label: "📦 Orders" },
    { key: "items", label: "🍽 Items" },
    { key: "inventory", label: "📦 Inventory" },
    { key: "offers", label: "🎁 Offers" },
    { key: "users", label: "👤 Users" },
    { key: "banners", label: "🖼 Banners" },
    { key: "notifications", label: "🔔 Notifications" },
    { key: "support", label: "💬 Support" },
    { key: "platform", label: "🛠 Platform" }
  ];

  return (
    <>
      {isMobile && !open ? (
        <button type="button" className="sidebar-open-fab" onClick={() => setOpen(true)} aria-label="Open menu">
          ☰
        </button>
      ) : null}
      {isMobile && open ? <button type="button" className="sidebar-backdrop" onClick={() => setOpen(false)} aria-label="Close menu" /> : null}
      <div className={`sidebar ${open ? "open" : "closed"} ${isMobile ? "mobile" : ""}`}>

        {/* 🔥 TOGGLE (MOBILE ONLY) */}
        {isMobile ? (
          <button type="button" className="toggle-btn" onClick={() => setOpen(!open)}>
            ☰
          </button>
        ) : null}

        {/* 🔥 TITLE */}
        <h2 className="logo">
          {open ? "🔥 Admin Panel" : "🔥"}
        </h2>

        {/* 🔥 MENU */}
        <div className="menu">
          {menu.map((item) => (
            <button
              type="button"
              key={item.key}
              className={`menu-item ${active === item.key ? "active" : ""}`}
              onClick={() => setActive(item.key)}
            >
              {open || !isMobile ? item.label : item.label.split(" ")[0]}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}